import React from 'react'

function ViewVariation() {
    return (
        <div>ViewVariation</div>
    )
}

export default ViewVariation